module.exports = __webpack_public_path__ + "img/cc.cc5cc309b.svg";